import { useTranslation } from 'react-i18next'
import { OnboardingPauseAndRewardIcon } from '../../../icons/OnboardingPauseAndRewardIcon'

export function PauseAndRewardSlide() {
  const { t } = useTranslation()

  return (
    <div className="onboarding-page__slide">
      <OnboardingPauseAndRewardIcon />
      <div className="onboarding-page__text-container">
        <h1 className="onboarding-page__title">{t('onboarding.pauseAndReward.title')}</h1>
        <p className="onboarding-page__description">
          {t('onboarding.pauseAndReward.description')}
        </p>
      </div>
    </div>
  )
}
